<template>
  <div class="control__elements">
    <LeafletMapView
      :pickable="true"
      :read-only="readOnly"
      :value="value"
      class="field-geo-data__map"
      @picked="update($event)"
    />
    <div v-show="touched && !valid" class="error">
      {{ error }}
    </div>
  </div>
</template>

<script>
import rowEditField from '@baserow/modules/database/mixins/rowEditField'
import LeafletMapView from '@baserow/modules/database/components/map/LeafletMapView'

export default {
  name: 'RowEditFieldGeoData',
  components: { LeafletMapView },
  mixins: [rowEditField],
  emits: ['update'],
  methods: {
    update(latLng) {
      this.$emit('update', latLng, this.value)
      this.touch()
    },
  },
}
</script>
